var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLowPriority = function SvgLowPriority(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5286 12.4708C7.78894 12.7311 8.21106 12.7311 8.4714 12.4708L11.8047 9.13742C12.0651 8.87707 12.0651 8.45496 11.8047 8.19461C11.5444 7.93426 11.1223 7.93426 10.8619 8.19461L8 11.0565L5.13807 8.19461C4.87772 7.93426 4.45561 7.93426 4.19526 8.19461C3.93491 8.45496 3.93491 8.87707 4.19526 9.13742L7.5286 12.4708Z",
    fill: "#09B965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5286 7.80409C7.78894 8.06444 8.21106 8.06444 8.4714 7.80409L11.8047 4.47075C12.0651 4.2104 12.0651 3.78829 11.8047 3.52794C11.5444 3.26759 11.1223 3.26759 10.8619 3.52794L8 6.38987L5.13807 3.52794C4.87772 3.26759 4.45561 3.26759 4.19526 3.52794C3.93491 3.78829 3.93491 4.2104 4.19526 4.47075L7.5286 7.80409Z",
    fill: "#09B965"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLowPriority);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "low-priority.bc5d06825075c6c7ba99743839765ed8.svg";